<template>
    <div>
        <nav aria-label="Page navigation example ">

            <ul class="pagination  justify-content-center" id="pagination">
                <li class="page-item">
                    <span class="page-link" v-if="pagnationDate.prev_page_url"
                        @click="pagnation(pagnationDate.prev_page_url);activeclass(current_page-2)">قبلی</span>
                </li>

                <li class="page-item" v-for="(item, index) in pageNumber" :key="index">
                    <a class="page-link " v-bind:class="current_page==index+1 ? `isActive` : ``"
                       @click="pagnation(`${api}${search}page=`+item );activeclass(index)">{{ item }}</a>
                </li>
                <li class="page-item" v-if="pagnationDate.next_page_url"><span class="page-link"
                        @click="pagnation(pagnationDate.next_page_url);activeclass(current_page)">بعدی</span></li>
            </ul>
        </nav>
    </div>
</template>

<script>

    import axios from 'axios';


    export default {
        props: {
            api: {
                type: String
            }
        },
        data() {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                items: [],
                pagnationDate: [],
                pageNumber: [],
                current_page: '',

                search: '?',

            }
        },
        mounted() {
            // `/api/services`
            this.pageNumbers(this.api)
            this.pagnation(this.api)

            if (this.api.includes('?search'))
                this.search = '&'
        },
        methods: {
            pagnation(api) {
                // console.log(api,4)

                this.$emit('pagnationChangeDate', api);
                axios.get(api, this.auth)
                    .then(response => {
                        this.pagnationDate = response.data
                        this.current_page = response.data.current_page
                        // this.items = response.data.data;
                         

                        //  console.log(this.pagnationDate)
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => this.loading = false)

            },
            pageNumbers(api) {
                
                axios.get(api, this.auth)
                    .then(response => {
                      
                        for (var i = 1; i <= response.data.last_page; i++) {
                            this.pageNumber = i
                           

                        }
                        
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => this.loading = false)

            },
            activeclass(item) {

                document.getElementById("pagination").querySelectorAll('a').forEach(element => {
                    //    element.classList=''
                    element.className = ""
                    // console.log(element.className="")
                    // console.log(element.classList="")
                });
                document.getElementById("pagination").querySelectorAll('a')[item].className = "isActive"


            }
        }

    }

</script>

<style>
    .isActive {
        color: #ffffff !important;
        background: #673AB7 !important;

    }

    .pagination{
        cursor: pointer;
    }


</style>
